module.exports = __webpack_public_path__ + "fonts/VetoSansCond-MediumItalic_1.24bd89d7.eot";